export default __webpack_public_path__ + "static/media/squirrel.e60ef188.jpg";